import api from "api";
import React, { useCallback, useEffect, useState } from "react";
import ContractFilter from "./ContractFilter";
import ContractTable from "./ContractTable";
import { Container } from "reactstrap";
import "./index.scss";
import { Pagination } from "shared";

const IFRS = () => {
  const [query, setQuery] = useState({
    page: 0,
    limit: 10,
    used_for_rental_fee_calculation: true,
  });

  const [metadata, setMetadata] = useState({ total: 0 });
  const [contracts, setContracts] = useState([]);

  const fetchData = useCallback(async () => {
    const res = await api.getContract(query);
    setContracts(res?.result?.contracts || []);
    setMetadata({ total: Math.ceil((res?.result?.total || 0) / query.limit) });
  }, [query]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const onPageChange = useCallback((page: number) => {
    setQuery(current => ({ ...current, page: page - 1}));
  }, []);

  return (
    <Container style={{ height: "100%" }}>
      <div className="ifrs__container">
        <div className="page-header">
          <span className="page-title">IFRS COMPLIANCE</span>
        </div>
        <ContractFilter query={query} setQuery={setQuery} />
        <ContractTable data={contracts} />
        <Pagination totalPage={metadata.total} onChange={onPageChange} />
      </div>
    </Container>
  );
};

export default IFRS;
